import { ref } from 'vue';

export class Clearable<T> {
	public inputValue = ref<T>();

	get valueOrNull(): T | null {
		return this.inputValue.value === '' || this.inputValue.value == null ? null : this.inputValue.value;
	}
}
